export default __webpack_public_path__ + "static/media/BP SOLAR.0d010340.jpg";